import React, { ReactElement, useState } from "react";
import ActionButton from "../../components/Buttons/ActionButton";

import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as ConsoleIcon } from "../../assets/icons/console.svg";
import { ReactComponent as DragIcon } from "../../assets/icons/drag_indicator.svg";
import { ReactComponent as CircleIcon } from "../../assets/icons/circle.svg";
import ConfirmModal from "../../components/Modals/ConfirmModal";
import { NavLink } from "react-router-dom";
import Modal from "../../components/Modals/Modal";
import AddButton from "../../components/Buttons/AddButton";
import { useDevice } from "../../Api/newSockets.api";
import { getDeviceTypeColor } from "../../constants/deviceTypes";
import { isDeviceSocketLive } from "../../utils/deviceSocket";

type Props = {
  subdevices?: any;
  device: any;
  groupId?: string;
  onClick?: any;
  className?: string;
  key?: any;
};

const DeviceListItem = (props: Props) => {
  const { deleteDevice } = useDevice();
  const [expanded, setExpanded] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const device = props.device;
  const groupId = device?.groupId;
  const deviceId = device?.id;

  const toggle = () => {
    setExpanded(!expanded);
  };
  const handleOpenModal = (e: React.MouseEvent<HTMLElement>) => {
    setModalOpen(true);
    console.log({ modalOpen });
    e.stopPropagation();
  };
  const handleDeleteDevice = () => {
    deleteDevice(deviceId)
      .then((data: any) => {
        console.log(data);
      })
      .catch((err: any) => {
        console.log(err);
      });
    setModalOpen(false);
  };
  const openConsole = (e: React.MouseEvent<HTMLElement>) => {
    alert("test");
    e.stopPropagation();
  };

  const dragDevice = (e: React.MouseEvent<HTMLElement>) => {
    alert("test");
    e.stopPropagation();
  };
  const onClose = () => {
    setModalOpen(false);
  };
  return (
    <div className={`device-list-items ${props.className}`}>
      <div className={`list-item`}>
        <div className="list-item-header" onClick={toggle}>
        <NavLink to={`/devices/${props.device.id}`}>
          <div className="list-item-title">
            <div className="device-main-info">
              <div
                className={`status-icon ${isDeviceSocketLive(device) ? "online" : "offline"}`}
              >
                <CircleIcon />
              </div>
              <img
                  src={`/devicetypes/${props.device.deviceTypes?.icon || "undefined"}.svg`}
                  className="device-type-icon"
                />
              <div className="list-item-name">{props.device.name}</div>
              {props.device.deviceTypes && (
                <span
                  className="device-type-chip"
                  style={{
                    backgroundColor: getDeviceTypeColor(props.device.deviceTypes.id).bg,
                    border: `1px solid ${getDeviceTypeColor(props.device.deviceTypes.id).border}`,
                    color: getDeviceTypeColor(props.device.deviceTypes.id).text,
                  }}
                >
                  {props.device.deviceTypes.name}
                </span>
              )}
            </div>
            <div className="device-meta-info">
              {props.device.port && (
                <span className="device-port-chip">
                  {props.device.port}
                </span>
              )}
              {(props.device.settings?.public_ip || props.device.settings?.cameraStreamEndpoint) && (
                <span className="list-item-ip">
                  {props.device.settings?.cameraStreamEndpoint ? (
                    <a
                      href={props.device.settings.cameraStreamEndpoint}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {props.device.settings.cameraStreamEndpoint}
                    </a>
                  ) : (
                    props.device.settings.public_ip
                  )}
                </span>
              )}
            </div>
          </div>
          </NavLink>
          <div className="list-item-actions">
            <ActionButton
              icon={<DeleteIcon />}
              onClick={handleOpenModal}
              className="list-item-action"
            />
            <Modal
              visible={modalOpen}
              onClose={onClose}
              onSubmit={handleDeleteDevice}
              title={`Delete ${props.device.name}?`}
              subtitle="Warning: this can't be undone"
              desc="By deleting device you're deleting all data related to device"
            />
            <ActionButton
              icon={<ArrowDownIcon className={expanded ? "rotated" : ""} />}
              className={`list-item-action `}
            />
            <ActionButton
              icon={<DragIcon />}
              onClick={dragDevice}
              className="list-item-action"
            />
          </div>
        </div>
        <div className={`list-item-body ${expanded && "expanded"}`}>
          <div className="device-data">
            <div className="column">
              <div className="row">
                <div className="label">Status</div>
                <div className="data">
                  {isDeviceSocketLive(device) ? "Online" : "Offline"}
                </div>
              </div>
              <div className="row">
                <div className="label">Uptime</div>
                <div className="data">-</div>
              </div>
            </div>

            <div className="column">
              <div className="row">
                <div className="label">Procedure</div>
                <div className="data">-</div>
              </div>
              <div className="row">
                <div className="label">Port</div>
                <div className="data">
                  {props.device.port ? props.device.port : "-"}
                </div>
              </div>
            </div>

            <div className="column">
              <div className="row">
                <div className="label">IP</div>
                <div className="data">
                  {props.device.settings?.cameraStreamEndpoint ? (
                    <a
                      href={props.device.settings.cameraStreamEndpoint}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {props.device.settings.cameraStreamEndpoint}
                    </a>
                  ) : (
                    props.device.settings?.public_ip || "-"
                  )}
                </div>
              </div>
              {/* <div className="row">
                            <div className="label">MAC</div>
                            <div className="data">-</div>
                        </div> */}
              <div className="row">
                <div className="label">Type</div>
                {/* <div className="data">{device.Type}</div> */}
                <div className="data">-</div>
              </div>
            </div>

            <div className="column">
              <div className="row">
                <div className="label">Board</div>
                <div className="data">{props.device.board}</div>
              </div>
              <div className="row">
                <div className="label">Device</div>
                <div className="data">{props.device.name}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {props.subdevices &&
        props.subdevices.map((device: any, i: any) => {
          return (
            <DeviceListItem
              key={i}
              device={device}
              groupId={props.groupId}
              className="sub-item"
            />
          );
        })}
    </div>
  );
};

export default DeviceListItem;
